import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo14/Unidad3Actividad8.mp3";

const Actividad4 = () => {
  const infoUnidad = modulo14.content[2];
  const infoAct = modulo14.content[2].activities[10];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo14.content[2].name}: ${modulo14.content[2].activities[11].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[2].path}/${modulo14.content[2].activities[11].path}`,
    titlePrev: `${modulo14.content[2].name}: ${modulo14.content[2].activities[9].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[2].path}/${modulo14.content[2].activities[9].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo14.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
      <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-md-10">
          <ul>
            <li>
              Ahora elabora un cartel que promueva que en las instituciones
              públicas de nuestro país se usen las lenguas originarias de la
              zona y no solamente castellano.
            </li>
            <li>
              Consulta las actividades 1 y 2 de esta Unidad para decidir cómo
              harás el cartel: puedes escoger hablar de alguna institución o
              lengua en particular si prefieres.
            </li>
            <li>
              Consulten las actividades anteriores para decidir cómo harán el
              cartel: pueden escoger hablar de alguna institución o lengua en
              particular si prefieren.
            </li>
            <li>Presenta el cartel en un papelote.</li>
          </ul>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea todas las indicaciones. Antes de hacer el cartel, verifique que
            recuerden algunas instituciones públicas y sus funciones, así como
            la variedad de lenguas que existe en el país. Para ello, pueden
            recurrir a la Actividad 1 de la Unidad 3. Si la actividad no está
            clara puede poner un ejemplo:
            <ul>
              <li>
                "Voy a escoger como institución pública la posta. En la posta
                atienden a diversas personas por problemas de salud. Entonces,
                me parece importante que, en la posta de un poblado donde se
                habla quechua, atiendan a la población en castellano y en
                quechua. Haré un cartel en dos idiomas que diga: VENGA A LA
                POSTA. ATENDEMOS EN QUECHUA O CASTELLANO. Además haré un dibujo
                de personas contentas poniéndose vacunas".
              </li>
            </ul>
          </li>
          <li></li>
          <li>
            Mientras trabajan observe su trabajo. Antes de pasar el cartel al
            papelote, revise las versiones finales. Pida que presenten el
            cartel. Pregunte qué institución y qué lengua escogieron. Pregunte
            por qué les pareció importante hacer esa elección. Cuelgue los
            papelotes.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad4;
